<div class="ya-input-container-flexwidth">
  <div class="ya-input-wrapper">
    <select a11y_Select #CustomSelectInput class="ya-input-text select-list" [value]="inputValue"
      (change)="genderSelectionChanged($event.currentTarget.value)">
      <option value="" disabled selected hidden><span>{{setPalceholder()}}</span></option>
      <ng-container *ngFor="let inputData of inputDataList">
        <option [value]="inputData.value"><span [langkey]="inputData.key"></span></option>
      </ng-container>
    </select>
    <ng-content></ng-content>
  </div>
</div>